module.exports = __webpack_public_path__ + "static/media/C.ff08f22a.png";